import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'
import React from 'react'
import { useMemo } from 'use-memo-one'

import { activeConfirmDialogAtom } from './atoms'
import { ConfirmDialog } from './confirm-dialog'

import type { ConfirmDialogProps } from './confirm-dialog'
import type { TypeHelper } from '@blade/std-lib'
import type { ChildrenProps } from '@root/shared/react'

type DialogsContextType = {
  openDialog: (
    props: TypeHelper.OmitKey<ConfirmDialogProps, 'open' | 'onOpenChange'>,
  ) => void
}

export const DialogsContext = React.createContext<DialogsContextType>({
  openDialog: (_) => {},
})

export const DialogsProvider: React.FC<ChildrenProps> = ({ children }) => {
  const [activeConfirmDialogProps, setActiveConfirmDialogProps] = useAtom(
    activeConfirmDialogAtom,
  )

  const ctxValue = useMemo(
    (): DialogsContextType => ({
      openDialog: (props) => {
        setActiveConfirmDialogProps(props)
      },
    }),
    [setActiveConfirmDialogProps],
  )

  return (
    <DialogsContext.Provider value={ctxValue}>
      {children}
      <AnimatePresence>
        {activeConfirmDialogProps ? (
          <ConfirmDialog
            {...activeConfirmDialogProps}
            onOpenChange={(open) => {
              if (!open) {
                setActiveConfirmDialogProps(undefined)
              }
            }}
          />
        ) : undefined}
      </AnimatePresence>
    </DialogsContext.Provider>
  )
}
